import type {ConnectElementConfig} from '../../../connect/ConnectJSInterface/ConnectElementList';
import {ComponentOverrideFlag} from '../../../utils/flags/flags';

export const appSettingsDynamicImport = async () => {
  const dynamicImport = await import(
    /* webpackChunkName: "appSettings" */ '../../../components/Apps/AppSettings'
  );
  return dynamicImport;
};

export const appAppSettingsParameter = 'app';
export const platformUserIdAppSettingsParameter = 'user-id';

const appSettingsParams = [
  appAppSettingsParameter,
  platformUserIdAppSettingsParameter,
] as const;
type AppSettingsParams = (typeof appSettingsParams)[number];
export type AppSettingsHtmlParams = Partial<Record<AppSettingsParams, string>>;

export const AppSettingsConfig: ConnectElementConfig = {
  Component: appSettingsDynamicImport,
  htmlAttributes: {
    app: {
      // TODO: Missing API review, however this is going to be exposed to preview platforms
      isInternal: false,
    },
    'user-id': {
      // TODO: Missing API review, however this is going to be exposed to preview platforms
      isInternal: false,
    },
  },
  enabledKey: 'app_onboarding',
  enabledOverrideFlag: ComponentOverrideFlag.app_onboarding,
  releaseState: 'preview',
  sentryTeam: 'app_platform',
  teamOwner: 'stripe-app-platform',
  description:
    'Renders a Stripe app - more specifically, renders the "embedded.settings" viewport on the configured stripe app id.',
  friendlyName: 'App settings',
  syntheticTestInfo: {
    testUrl:
      'https://amp.corp.stripe.com/synthetics/us-west-2/embedded-app-settings',
  },
  deprecated: {
    deprecatedMessage:
      'The app settings component is deprecated. Please use the app viewport component instead.',
  },
};
